import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    Header,
    ContentBody,
    HeaderContainer,
    DetailBody,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import { useTranslation } from 'react-i18next';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import PdfLoading from 'src/pages/orders/components/reportsAndInvoice/viewReport/PdfLoading';
import {
    isIpad,
    isMobileView,
    downloadFile,
    updateContainerPosition,
} from 'src/utils/util';
import { PdfMainContainer } from './AddPo.styled';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const PoImagePreview = (props) => {
    const { poImagePreviewDetails, poImagePreviewLoader } = useSelector(
        (state) => state.consignmentDetailsReducer
    );

    useEffectWithErrorLogging(() => {
        if (
            !poImagePreviewLoader &&
            poImagePreviewDetails &&
            !(isImageFile() || poImagePreviewDetails.type === 'pdf')
        ) {
            downloadFile(getUrl(), poImagePreviewDetails.name);
        }
    }, [poImagePreviewLoader, poImagePreviewDetails]);
    const [numPages, setNumPages] = useState(null);
    
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    const { t } = useTranslation();
    const getUrl = () => {
        let url = '';
        if (poImagePreviewDetails.type === 'doc') {
            url = `data:application/msword;base64,${poImagePreviewDetails.base64}`;
        } else if (poImagePreviewDetails.type === 'pdf') {
            url = `data:application/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`;
        } else {
            url = `data:image/${poImagePreviewDetails.type};base64,${poImagePreviewDetails.base64}`;
        }
        return url;
    };

    const isImageFile = () => {
        const { type: typeFromImageDetails } = poImagePreviewDetails;
        const type = typeFromImageDetails.toLowerCase();
        return type === 'png' || type === 'jpg' || type === 'jpeg';
    };

    useEffectWithErrorLogging(() => {
        if (isMobileView()) {
            if (poImagePreviewLoader)
                updateContainerPosition('#UsageContainer', 'unset');
            else {
                updateContainerPosition('#UsageContainer', 'fixed');
            }
        }
    }, [poImagePreviewLoader]);

    return (
        <>
            {poImagePreviewLoader ? (
                <>
                    <Backdrop
                        showCloseButton={false}
                        showBackdrop={true}
                        isModal
                        loaderBackground
                    >
                        <Spinner id="consignmentBilling-poImagePreview-poImagePreview-loadingSpinner" animation="border" variant="primary" small />
                    </Backdrop>
                </>
            ) : (
                <>
                    {isImageFile() || poImagePreviewDetails.type === 'pdf' ? (
                        <ModalDialog
                            modalHeight={'calc(100vh - 150px)'}
                            modalWidth={'70%'}
                            left={'0%'}
                            right={'0%'}
                            top={'7%'}
                            bottom={'5%'}
                            padding={'0px'}
                            height={'100%'}
                            marginTop={'6.75rem'}
                            zIndex={'30000'}
                            width={'50%'}
                            handleClose={()=>props.closePoImagePreview()}
                        >
                            <ContentBody contentHeight={'calc(100% - 16px)'}>
                                <HeaderContainer>
                                    <Header fontSize="18px">{t('equity.shipping.addPoTissue.POImage')}</Header>
                                </HeaderContainer>

                                <DetailBody
                                    detailBodyPadding={'0px'}
                                    overflowX={'hidden'}
                                    pdfContainerHeight={
                                        poImagePreviewLoader ? '100%' : 'unset'
                                    }
                                    scrollBarWidth={'8px'}
                                    scrollBarBackgroundColor={'#888'}
                                    scrollBarBorderRadius={'10px'}
                                    mediumDeviceScrollBarDisplay={'block'}
                                >
                                    {poImagePreviewDetails ? (
                                        !poImagePreviewLoader &&
                                        poImagePreviewDetails.base64 ? (
                                            <PdfMainContainer
                                            >
                                                {isImageFile() ? (
                                                    <img
                                                        height={'100%'}
                                                        width={'100%'}
                                                        src={getUrl()}
                                                    />
                                                ) : (
                                                    <Document
                                                        file={getUrl()}
                                                        onLoadSuccess={
                                                            onDocumentLoadSuccess
                                                        }
                                                        width="100%"
                                                        renderMode={'canvas'}
                                                        loading={<PdfLoading />}
                                                    >
                                                        {[
                                                            ...Array(
                                                                numPages
                                                            ).keys(),
                                                        ].map(
                                                            (
                                                                element,
                                                                index
                                                            ) => (
                                                                <Page
                                                                    index={
                                                                        element +
                                                                        1
                                                                    }
                                                                    pageNumber={
                                                                        element +
                                                                        1
                                                                    }
                                                                    scale={
                                                                        isIpad() ||
                                                                        isMobileView()
                                                                            ? 1.0
                                                                            : 1.5
                                                                    }
                                                                    key={index}
                                                                />
                                                            )
                                                        )}
                                                    </Document>
                                                )}
                                            </PdfMainContainer>
                                        ) : (
                                            <PdfLoading />
                                        )
                                    ) : null}
                                </DetailBody>
                            </ContentBody>
                        </ModalDialog>
                    ) : null}
                </>
            )}
        </>
    );
};

export default PoImagePreview;
